export default {
    methods: {
        updateConfig(value, key) {
            let config = { ...this.form.config };
            config[key] = value;
            this.form.config = config;
        }
    }
}